import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';

import SuspenseLoader from "./utils/SuspenceLoader";

const Accounts = React.lazy(() => import('./pages/Accounts/Accounts'));
const AccountDetail = React.lazy(() => import('./pages/Accounts/AccountDetail'));
const Customers = React.lazy(() => import('./pages/Customers/Customers'));
const CustomerDetail = React.lazy(() => import('./pages/Customers/CustomerDetail'));
const Dashboard = React.lazy(() => import('./pages/Dashboard/Dashboard'));
const Menus = React.lazy(() => import('./pages/Menus/Menus'));
const MenuDetail = React.lazy(() => import('./pages/Menus/MenuDetail'));
const NotFound = React.lazy(() => import('./pages/NotFound/NotFound'));
const Orders = React.lazy(() => import('./pages/Orders/Orders'));
const OrderDetail = React.lazy(() => import('./pages/Orders/OrderDetail'));

function Routing({ expanded, sidebar }) {
    return (
        <BrowserRouter basename={window.location.host.indexOf('aws') > 0 ? '/Prod' : '/'}>
            {sidebar}
            <div className={`App ${expanded}`}>
                <Routes>
                    <Route path="/" element={<SuspenseLoader><Dashboard /></SuspenseLoader>} />
                    <Route path="accounts" element={<SuspenseLoader><Accounts /></SuspenseLoader>} />
                    <Route path="account/:accountId" element={<SuspenseLoader><AccountDetail /></SuspenseLoader>} />
                    <Route path="customers" element={<SuspenseLoader><Customers /></SuspenseLoader>} />
                    <Route path="customer/:customerId" element={<SuspenseLoader><CustomerDetail /></SuspenseLoader>} />
                    <Route path="menus" element={<SuspenseLoader><Menus /></SuspenseLoader>} />
                    <Route path="menu/:menuId" element={<SuspenseLoader><MenuDetail /></SuspenseLoader>} />
                    <Route path="orders" element={<SuspenseLoader><Orders /></SuspenseLoader>} />
                    <Route path="order/:orderId" element={<SuspenseLoader><OrderDetail /></SuspenseLoader>} />
                    <Route path="*" element={<SuspenseLoader><NotFound /></SuspenseLoader>} />
                </Routes>
            </div>
        </BrowserRouter>
    );
};

export default Routing;